import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { numbers } from 'app/utils';
import * as activityHelper from 'modules/activity/activityHelper';
import ActivityText from 'modules/activity/activityText.component';
import UAvatar from 'modules/user/UAvatar.component';
import {
  Box,
  Row,
  View,
  SecondaryText,
  BodyText,
  Image,
  DividerLine,
  Pressable,
  InlineLink,
} from 'modules/styled';
import { MAX_POST_WIDTH } from 'styles/layout';

export default class SingleActivity extends PureComponent {
  static propTypes = {
    actions: PropTypes.object,
    singleActivity: PropTypes.shape({
      totlaUsers: PropTypes.number,
      amount: PropTypes.number,
      byUser: PropTypes.object, // TODO create user prop type validation
      post: PropTypes.object, // TODO create post prop type validation
      type: PropTypes.string,
      text: PropTypes.string,
      createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }).isRequired,
    screenSize: PropTypes.number,
    PostComponent: PropTypes.object,
  };

  renderName(activity, user) {
    const { actions } = this.props;
    if (!user && activity.totalUsers) {
      let s = '';
      if (activity.totalUsers > 1) s = 's';
      return (
        <Box sx={{ mr: 1 }}>
          {activity.totalUsers} user{s}{' '}
        </Box>
      );
    }
    if (!user) return null;

    if (user && user.handle && activity.totalUsers - 1) {
      let s = '';
      if (activity.totalUsers - 1 > 1) s = 's';
      return (
        <Box sx={{ mr: 1 }}>
          <InlineLink
            nativeAction={() => actions.goToProfile(user)}
            to={'/user/profile/' + user.handle}
          >
            <BodyText sx={{ color: 'blue' }}>@{user.handle}</BodyText>
          </InlineLink>
          <BodyText>
            {activity.totalUsers - 1} other{s}
          </BodyText>
        </Box>
      );
    }
    if (user.handle) {
      return (
        <Box sx={{ mr: 0.7501 * 8 }}>
          <InlineLink
            nativeAction={() => actions.goToProfile(user)}
            to={'/user/profile/' + user.handle}
          >
            <BodyText sx={{ color: 'blue' }}>@{user.handle}</BodyText>
          </InlineLink>
        </Box>
      );
    }
    return <Box sx={{ mr: 0.7501 * 8 }}>user.name</Box>;
  }

  renderIcon(img) {
    if (!img) {
      return null;
    }
    return <Image sx={{ width: 4, height: 3.5 }} resizeMode={'contain'} source={img} />;
  }

  renderPostPreview(activity) {
    const { PostComponent, actions } = this.props;
    const { post } = activity;

    const parentId = post.parentPost ? post.parentPost._id || post.parentPost : post._id;

    const link = post.metaPost || post.parentPost;
    // TODO hack should normalize in reducer
    // if (post.parentPost) post.parentPost = post.parentPost._id;

    const community = post.community || post.data ? post.data.community : null;
    const linkToPost = `/${community}/post/${parentId}`;

    const onPress = () => actions.goToPost({ _id: parentId, community });

    return (
      <View sx={{ mx: [2, 4] }}>
        <Pressable
          // bgHover={'lightGreyBg'}

          to={linkToPost}
          nativeAction={onPress}
        >
          <PostComponent
            post={post}
            link={link}
            hideDivider
            hidePostButtons
            preview
            noLink
          />
        </Pressable>
      </View>
    );
  }

  renderActivity(activity) {
    const { screenSize, actions } = this.props;
    const { emoji, image, byUser } = activityHelper.getActivityParams(activity);
    const amount = numbers.abbreviateNumber(activity.amount);
    return (
      <Row sx={{ flex: 1, alignItems: 'center' }}>
        <View sx={{ alignSelf: 'flex-start', mr: 1.5001 * 8 }}>
          {this.renderIcon(image)}
          {emoji ? (
            <BodyText sx={{ fontSize: 4 * 8, lineHeight: 4.2 * 8, pt: 1 }}>
              {emoji}
            </BodyText>
          ) : null}
          {byUser && <UAvatar goToProfile={actions.goToProfile} user={byUser} size={5} />}
        </View>
        <View sx={{ alignItems: 'baseline' }}>
          <Row
            sx={{
              flexWrap: 'wrap',
              alignItems: 'baseline',
              justifyContent: 'flex-start',
            }}
          >
            {this.renderName(activity, byUser)}
            <ActivityText activity={activity} amount={amount} />
          </Row>
          <View>{screenSize ? this.renderDate(activity) : null}</View>
        </View>
      </Row>
    );
  }

  renderDate(activity) {
    const fromNow = numbers.getTimestamp(activity.createdAt);
    return activity.type ? (
      <SecondaryText sx={{ lineHeight: 2 }}>{fromNow}</SecondaryText>
    ) : null;
  }

  renderComment(activity) {
    const { PostComponent } = this.props;
    const { post, amount, byUser } = activity;

    post.embeddedUser = byUser;
    return (
      <View sx={{ maxWidth: MAX_POST_WIDTH * 8 }}>
        <View sx={{ mx: [2, 4] }}>
          <PostComponent
            post={post}
            hidePostButtons
            preview
            hideDivider
            avatarText={() => <ActivityText activity={activity} amount={amount} />}
          />
        </View>
        <DividerLine sx={{ mt: 2 }} />
      </View>
    );
  }

  render() {
    const { screenSize } = this.props;
    const activity = this.props.singleActivity;
    if (!activity) return null;

    if (['commentMention', 'comment', 'mention'].includes(activity.type))
      return this.renderComment(activity);

    return (
      <View sx={{ maxWidth: MAX_POST_WIDTH * 8 }}>
        <Row
          sx={{
            flex: 1,
            mt: 4,
            mx: [2, 4],
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {this.renderActivity(activity)}
          {screenSize ? null : this.renderDate(activity)}
        </Row>
        {activity.post ? (
          <View sx={{ m: 0, ml: [5.5 * 8, 6], pr: 0 }}>
            {this.renderPostPreview(activity)}
          </View>
        ) : (
          <View sx={{ mt: [0, 4] }} />
        )}
        <DividerLine sx={{ mt: 2 }} />
      </View>
    );
  }
}
